import {
    CREATE_SESSION,
    DELETE_TRIAL_LOG,
    DELETE_SESSION,
    EDIT_SESSION,
    EDIT_SESSION_STATUS,
    END_SESSION,
    GET_SESSION_BY_ID,
    GET_SESSIONS,
    PAUSE_SESSION,
    REFRESH_SESSION,
    RESUME_SESSION,
    SAVE_SESSION_TARGET_OPTION,
    EDIT_SESSION_GOALS,
    EDIT_SESSION_TIMELINE,
    GET_SESSION_CORRECTIONS,
    APPLY_SESSION_DATA_CORRECTIONS,
    GET_MANUAL_SESSION_APPTS,
    GET_MANUAL_SESSION,
    SAVE_MANUAL_SESSION,
    RESET_MANUAL_SESSION,
    GET_MANUAL_MAINTENANCE_CHECKS,
} from './session.types';

/** Sessions */

export const createSession = (body, apptId) => {
    return {
        type: CREATE_SESSION,
        payload: { body, apptId },
    };
};

export const getSessions = (params, load) => {
    return {
        type: GET_SESSIONS,
        payload: { params, load },
    };
};

export const getSessionById = (id, load) => {
    return {
        type: GET_SESSION_BY_ID,
        payload: { id, load },
    };
};

export const resumeSession = (id) => {
    return {
        type: RESUME_SESSION,
        payload: { id },
    };
};
export const pauseSession = (id) => {
    return {
        type: PAUSE_SESSION,
        payload: { id },
    };
};

export const endSession = (id) => {
    return {
        type: END_SESSION,
        payload: { id },
    };
};

export const saveSessionTargetOption = (sessionId, body) => {
    return {
        type: SAVE_SESSION_TARGET_OPTION,
        payload: { sessionId, body },
    };
};

export const deleteTrialLog = (sessionId, tSummaryId, trialId) => {
    return {
        type: DELETE_TRIAL_LOG,
        payload: { sessionId, tSummaryId, trialId },
    };
};

export const refreshSession = (sessionId) => {
    return {
        type: REFRESH_SESSION,
        payload: { sessionId },
    };
};

export const editSessionGoals = (id, body) => {
    return {
        type: EDIT_SESSION_GOALS,
        payload: { id, body },
    };
};

export const editSessionTimeline = (id, body) => {
    return {
        type: EDIT_SESSION_TIMELINE,
        payload: { id, body },
    };
};

export const getSessionCorrections = (id) => {
    return {
        type: GET_SESSION_CORRECTIONS,
        payload: { id },
    };
};

/** Commits one edit-mode batch on a COMPLETED session: `{ reason?, changes: [{ op, ... }] }`. */
export const applySessionDataCorrections = (id, body) => {
    return {
        type: APPLY_SESSION_DATA_CORRECTIONS,
        payload: { id, body },
    };
};

/** End */

/** Manual session data entry */

export const getManualSessionAppts = (params) => {
    return {
        type: GET_MANUAL_SESSION_APPTS,
        payload: { params },
    };
};

/** Loads a MANUAL session for editing into `manualSession` — kept apart from `sessionById` (the live screen). */
export const getManualSession = (id) => {
    return {
        type: GET_MANUAL_SESSION,
        payload: { id },
    };
};

export const saveManualSession = (body) => {
    return {
        type: SAVE_MANUAL_SESSION,
        payload: { body },
    };
};

/**
 * The maintenance checks due in the manual session being entered (`{ clientId, date, localDate, sessionId }`),
 * with their goals, into `manualMaintenanceChecks`. They are never picked — the data entry screen adds them.
 */
export const getManualMaintenanceChecks = (params) => {
    return {
        type: GET_MANUAL_MAINTENANCE_CHECKS,
        payload: { params },
    };
};

export const resetManualSession = () => {
    return {
        type: RESET_MANUAL_SESSION,
    };
};

/** End */
